import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "details"]

  connect() {
    // Initial state is already set via server-side rendering
  }

  toggleService(event) {
    const checkbox = event.target
    const serviceType = checkbox.dataset.service
    const isChecked = checkbox.checked

    // Find the details section for this service
    const detailsSection = this.detailsTargets.find(
      el => el.dataset.service === serviceType
    )

    if (detailsSection) {
      if (isChecked) {
        // Show with animation
        detailsSection.classList.remove('hidden')
        detailsSection.style.opacity = '0'
        detailsSection.style.transform = 'translateY(-10px)'

        requestAnimationFrame(() => {
          detailsSection.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
          detailsSection.style.opacity = '1'
          detailsSection.style.transform = 'translateY(0)'
        })

        // Scroll into view smoothly
        setTimeout(() => {
          detailsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }, 100)
      } else {
        // Hide with animation
        detailsSection.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
        detailsSection.style.opacity = '0'
        detailsSection.style.transform = 'translateY(-10px)'

        setTimeout(() => {
          detailsSection.classList.add('hidden')
        }, 200)

        // Uncheck all checkboxes within the hidden section
        const checkboxes = detailsSection.querySelectorAll('input[type="checkbox"]')
        checkboxes.forEach(cb => cb.checked = false)
      }
    }

    // Update the toggle label styling
    const label = checkbox.closest('label')
    if (label) {
      if (isChecked) {
        label.classList.add('ring-2')
      } else {
        label.classList.remove('ring-2')
      }
    }
  }
}
